import emptyImage from '../assets/images/emptyLogo.svg';
import loginImage from '../assets/images/LoginImage.png';
import logo from '../assets/images/logos/Logo.png';
import logoHorizontal from '../assets/images/logos/LogoHorizontal.png';

export const LOGO_DEFAULT = logo;
export const LOGO_HORIZONTAL_DEFAULT = logoHorizontal;
export const EMPTY_IMAGE = emptyImage;
export const LOGIN_IMAGE = loginImage;
export const URL_LOCALHOST_DEFAULT = 'http://localhost:3000';
export const COLOR_DEFAULT = 'rgba(0, 47, 197, 1)';
export const COLOR_DEFAULT_LIGHT = 'rgba(0, 47, 197, 0.08)';
export const CONTACT_CHANNEL_PHONE_DEFAULT = '0800-12345';
export const GOOGLE_CAPTCHA_API_KEY = '6LduOAoaAAAAAJ-Aa84QpXxKf8oCEdv6XOE9M5-2';
export const REGEX_PASSWORD = '^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[!@#$%^&*.()_]).{8,}$';
export const COUNTRY_PHONE_DEFAULT = 'mx';
export const COLOR_BO = 'rgba(0, 47, 197, 1)';

//DATE FORMATS
export const DATE_FORMAT_HOUR = 'HH:mm';
export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_FORMAT_WITH_HOUR = 'DD/MM/YYYY - HH:mma';

//SERVICES
export const MAX_NUMBER_SERVICES_DEFAULT = 8;

//MATERIALS
export const PET_MATERIAL = 'PET_MATERIAL';
export const ESTATE_MATERIAL = 'ESTATE_MATERIAL';
export const VEHICLE_MATERIAL = 'VEHICLE_MATERIAL';
export const PERSON_MATERIAL = 'PERSON_MATERIAL';

export const MAX_NUMBER_MATERIALS_DEFAULT = 6;
export const MAX_NUMBER_PLANS_DEFAULT = 6;

//
export const NAME_APP = 'Portal Autogestión';
